const config = {
  pageLimit: 20,
  baseUrl: process.env.REACT_APP_BASE_URL,
  flutterwaveKey: process.env.REACT_APP_FLUTTERWAVE_KEY,
}
export { config }